import type { ValidationErrors } from 'fluentvalidation-ts'
import { useCallback } from 'react'

import { useSyncState } from './useSyncState'

const DEFAULT_VALIDATION: ValidationErrors<unknown> = {}

/**
 * Хук для проведения валидации состояния
 *
 * // TODO: имеется копия в utils, оттуда нужно убрать
 */
export const useCheckValidity = <T extends Record<string, unknown>>(
  checker: (value: T) => ValidationErrors<T>,
  initialValue?: T,
) => {
  const getValue = useCallback((): ValidationErrors<T> => {
    try {
      return initialValue ? checker(initialValue) : DEFAULT_VALIDATION
    } catch {
      return DEFAULT_VALIDATION
    }
  }, [checker, initialValue])

  const [validation, setValidation] = useSyncState(getValue)

  const setCheck = (item: T) => {
    const validation = checker(item)
    setValidation(validation)
    const isValid = getIsValid(validation)
    return isValid
  }

  const isValid = getIsValid(validation)

  return [validation, isValid, setCheck] as const
}

function getIsValid<T>(validation: ValidationErrors<T>) {
  return Object.keys(validation).length === 0
}
